<template>

<app-input class="pool" :label="label" :stacked="stacked" :warning="warning" :no-line="true" :toggle="toggle" :locked="locked" :notes="notes" :disabled="disabled" :validation="validation">

    <div class="pool-selected" v-if="selectedOptions.length">

        <transition-group name="flip-list" tag="div">

        <div class="pool-selected-item" v-for="(option, index) in selectedOptions" :key="option.value">

            <div class="pool-selected-item-text">{{ option.text }}</div>

            <div class="pool-selected-item-buttons">

                <app-icon icon="caret-up" theme="grey" v-tooltip="'Move up'" class="pool-selected-item-buttons-item" v-on:click="onUpClick(index)" :disabled="index === 0" />
				<app-icon icon="caret-down" theme="grey" v-tooltip="'Move down'" class="pool-selected-item-buttons-item" v-on:click="onDownClick(index)" :disabled="index === value.length - 1" />
                <app-icon icon="pool.remove" v-tooltip="'Remove from selected'" theme="red" class="pool-selected-item-buttons-item" v-on:click="onRemoveClick(option.value)" />
                
            </div>

        </div>

        </transition-group>

    </div>

	<div class="pool-actions">

        <div class="pool-actions-buttons">

            <app-icon icon="chevron.down.circle" v-if="availableOptions.length && collapsed && value.length && !expanded" v-tooltip="'Show available'" class="pool-actions-toggle-item" v-on:click="onExpandClick"  />
            <app-icon icon="chevron.up.circle" v-if="availableOptions.length && collapsed && value.length && expanded" v-tooltip="'Hide available'" class="pool-actions-toggle-item" v-on:click="onCollapseClick"  />

        </div>

        <div class="pool-actions-count" v-if="selectedOptions.length && availableOptions.length">{{ availableOptions.length }} more available</div>
        <div class="pool-actions-count" v-if="selectedOptions.length && !availableOptions.length"></div>
        <div class="pool-actions-count" v-if="!selectedOptions.length">{{ placeholder }}</div>

        <div class="pool-actions-buttons">

            <app-icon icon="pool.all" theme="blue" v-if="availableOptions.length > 1" v-tooltip="'Add all available to selected'" class="pool-actions-buttons-item" v-on:click="onAllClick"  />
            <app-icon icon="pool.clear" theme="red" v-if="selectedOptions.length > 1" v-tooltip="'Remove all from selected'" class="pool-actions-buttons-item" v-on:click="onClearClick" />

        </div>

    </div>

	<div class="pool-available" v-if="availableOptions.length && (!collapsed || expanded)">

        <div class="pool-available-item" v-tooltip="'Add to selected'" v-on:click="onAddClick(option.value)" v-for="option in availableOptions" :key="option.value">

            <div class="pool-available-item-text">{{ option.text }}</div>
            
            <div class="pool-available-item-buttons">
            
                <app-icon icon="pool.add" class="pool-available-item-buttons-item" />
				
            </div>

        </div>

    </div>

</app-input>

</template>

<script>

export default {

	props: ['validation', 'label', 'collapsed', 'warning', 'locked', 'value', 'toggle', 'stacked', 'notes', 'placeholder', 'options', 'disabled'],

	data: function() {

        return {
            is: {
                expanded: false
            }
        }

	},

    created: function() {

        if (!this.value.length && this.collaped) this.is.expanded = true
    
    },

	computed: {

        expanded: function() {
        
            if (this.collapsed) {
            
                return (this.value.length) ? this.is.expanded : true
            
            } else {
            
                return false

            }

        },

        selectedOptions: function() {

            var options = []

            this.$_.each(this.value, function(value) {

                var exists = this.$_.findWhere(this.options, {
                    value: value
                })

                if (exists) options.push(exists)
            
            }.bind(this))

            return options
        
        },

        availableOptions: function() {
        
            return this.$_.filter(this.options, function(option) {
            
                return !this.$_.contains(this.value, option.value)
            
            }.bind(this))
        
        }

	},

    watch: {
    
        value: function(n) {
        
            if (!n.length) this.is.expanded = true
        
        }

    },

	methods: {

        onExpandClick: function() {
        
            this.is.expanded = true

        },

        onCollapseClick: function() {
        
            this.is.expanded = false

        },

        onUpClick: function(index) {

            var values = this.$util.copy(this.value)

            var old = values[index - 1]

            values[index - 1] = values[index]
            values[index] = old

            this.$emit('input', values)

        },

        onDownClick: function(index) {

            var values = this.$util.copy(this.value)

            var old = values[index + 1]

            values[index + 1] = values[index]
            values[index] = old

            this.$emit('input', values)
        
        },

        onAddClick: function(value) {

            var values = this.$util.copy(this.value)

            values.push(value)

            this.$emit('input', values)

        },

        onRemoveClick: function(value) {

            var values = this.$_.filter(this.$util.copy(this.value), function(item) {
            
                return item !== value

            })

            this.$emit('input', values)

        },

        onAllClick: function() {

            var values = this.$util.copy(this.value)

            this.$_.each(this.availableOptions, function(item) {
            
                values.push(item.value)
            
            })
        
            this.$emit('input', values)
        
        },

        onClearClick: function() {
        
            this.$emit('input', [])
        
        }

	}

}

</script>

<style scoped>

.flip-list-move {
    transition: transform 0.5s ease;
}

.pool-available {
    max-height: 220px;
    overflow: auto;
    border-radius: 0px 0px 10px 10px;
    border: 2px solid #eee;
}

.pool-available-item,
.pool-selected-item {
    font-size: 14px;
	color: #343434;
	padding: 0px 8px;
	min-height: 40px;
	justify-content: space-between;
	line-height: 16px;
	user-select: none;
	display: flex;
	align-items: center;
	border: 2px solid #eee;
    border-top: 0px;
}

.pool-available-item {
    border: 0px;
	border-bottom: 2px solid #eee;
}

.pool-available-item:hover {
    color: #fff;
	cursor: pointer;
    border-color:  #4082d3;
	background-color: #4082d3;
}

.pool-selected-item:first-child {
    border-top: 2px solid #eee;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.pool-available-item:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-bottom: 0px;
}

.pool-actions {
    background-color: #eee;
	padding: 0px 10px;
	display: flex;
	align-items: center;
	min-height: 40px;
}

.pool-actions:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.pool-actions:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.pool-actions-count {
    font-size: 14px;
    color: #343434;
    flex-grow: 1;
}

.pool-actions-buttons:first-child > * {
    margin-left: 0px;
    margin-right: 10px;
}

.pool-available-item-buttons,
.pool-selected-item-buttons,
.pool-actions-buttons {
	flex-shrink: 0;
	display: flex;
}

.pool-selected-item-buttons-item,
.pool-actions-buttons-item {
	width: 24px;
	height: 24px;
	cursor: pointer;
	font-size: 14px;
	border-radius: 4px;
	line-height: 26px;
	text-align: center;
	color: #fff;
	margin-left: 10px;
}

.pool-actions-toggle-item {
	width: 24px;
	height: 24px;
	cursor: pointer;
	font-size: 20px;
	line-height: 24px;
    color: #999;
	text-align: center;
	margin-right: 5px;
}

.pool-available-item-buttons-item {
	width: 24px;
	height: 24px;
	font-size: 14px;
	line-height: 26px;
	text-align: center;
	color: #eee;
}

</style>